import React, { useEffect, useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { collection, getDocs, getFirestore, query, where } from 'firebase/firestore';
import { useAuth } from '../contexts/AuthContext';
import '../TopMenuBar.css';

const Icon = ({ name }) => {
  const paths = {
    search: <><circle cx="11" cy="11" r="6"/><path d="m16 16 4 4"/></>,
    bell: <><path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9"/><path d="M10 21h4"/></>,
    message: <><path d="M4 5h16v12H8l-4 4Z"/><path d="M8 9h8M8 13h5"/></>,
    menu: <><path d="M4 7h16M4 12h16M4 17h16"/></>,
  };

  return <svg className="ui-icon" viewBox="0 0 24 24" aria-hidden="true">{paths[name]}</svg>;
};

function TopMenuBar() {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [userId, setUserId] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const db = getFirestore();

  useEffect(() => {
    if (!currentUser) {
      setUserId(null);
      return;
    }

    const fetchUserId = async () => {
      try {
        const usersRef = collection(db, 'users');
        const snapshot = await getDocs(query(usersRef, where('uid', '==', currentUser.uid)));
        if (!snapshot.empty) setUserId(snapshot.docs[0].data().userId);
      } catch (error) {
        console.warn('Could not load the current profile.', error);
      }
    };

    fetchUserId();
  }, [currentUser, db]);

  const handleSearchSubmit = (event) => {
    event.preventDefault();
    if (searchQuery.trim()) navigate(`/profiles?goals=${encodeURIComponent(searchQuery.trim())}`);
  };

  const handleLogout = async () => {
    await logout();
    setMenuOpen(false);
    navigate('/');
  };

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="top-menu-bar">
      <div className="nav-inner">
        <Link to="/" className="wordmark" onClick={closeMenu} aria-label="ClimberLink home">
          Climber<span>Link</span>
        </Link>

        <nav className={menuOpen ? 'primary-nav is-open' : 'primary-nav'} aria-label="Primary navigation">
          <NavLink to="/" end onClick={closeMenu}>Basecamp</NavLink>
          <NavLink to="/profiles" onClick={closeMenu}>Network</NavLink>
          <NavLink to="/Trips" onClick={closeMenu}>Expeditions</NavLink>
          {currentUser && userId && <NavLink to={`/UserProfile/${userId}`} onClick={closeMenu}>Profile</NavLink>}
        </nav>

        <div className="nav-actions">
          <form className="global-search" onSubmit={handleSearchSubmit} role="search">
            <Icon name="search" />
            <input
              aria-label="Search climbers"
              value={searchQuery}
              onChange={(event) => setSearchQuery(event.target.value)}
              placeholder="Search climbers..."
            />
          </form>

          {currentUser ? (
            <>
              <button className="icon-button nav-desktop-action" type="button" aria-label="Notifications"><Icon name="bell" /></button>
              <button className="icon-button nav-desktop-action" type="button" aria-label="Messages"><Icon name="message" /></button>
              <button className="avatar-button" type="button" onClick={handleLogout} title="Log out">
                <img src={currentUser.photoURL || '/mtn.jpg'} alt="Your profile" />
              </button>
            </>
          ) : (
            <div className="auth-actions">
              <Link to="/login" className="text-link">Log in</Link>
              <Link to="/signup" className="nav-cta">Join now</Link>
            </div>
          )}

          <button
            type="button"
            className="mobile-menu-button"
            aria-label="Toggle navigation"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((open) => !open)}
          >
            <Icon name="menu" />
          </button>
        </div>
      </div>
    </header>
  );
}

export default TopMenuBar;
